module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"candidateRemoved":"The candidate was removed","candidateRemovedTip":"Someone removed the candidate while you were working with them.","toCandidateList":"Candidate list","vacancy":"Job","candidate":"Candidate","evaluationCandidate":"Evaluation of the candidate","evaluationCandidateAi":"Evaluation of the candidate from AI","summaryInterview":"Summary of the interview"}}')
  delete Component.options._Ctor
}
